import Vue from 'vue';
import Vuetify from 'vuetify';
import pt from 'vuetify/es5/locale/pt';
import 'vuetify/dist/vuetify.min.css';
import { themeVuetify } from './theme/theme';


Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: { ...themeVuetify },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: {
    iconfont: 'md',
  },
});



// WEBPACK FOOTER //
// ./src/config/vuetify.js